import {
  MarketYourBookAuthorImage,
  PromoteYourExistingBookAuthorImage,
  WriteaBookBWAuthorImage,
  WriteaBookColorAuthorImage,
} from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForAuthorsSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 4,
      title: 'Write a Book (Color)',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: WriteaBookColorAuthorImage,
      pointers: [
        'Full-color layouts with expert design',
        'Ideal for visual and instructional books',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 3,
      title: 'Write a Book (B&W)',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: WriteaBookBWAuthorImage,
      pointers: [
        'Professional editing & black-and-white design',
        'End-to-end publishing support',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'Promote Your Existing Book',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PromoteYourExistingBookAuthorImage,
      pointers: [
        'Boost discoverability for published books',
        'Performance-driven promotion strategy',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 1,
      title: 'Convert your book to Visual',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: MarketYourBookAuthorImage,
      pointers: [
        'Targeted promotion to reach the right readers',
        'Increased visibility across ZebraLearn channels',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Authors' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForAuthorsSection;
